import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, FormGroup, Button, ButtonGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import { isRequired } from '../../../../utils/validators';
import LocationSelect from '../../../common/forms/select/LocationSelect';
import DatePicker from '../../../common/forms/input/DatePicker';

const FORM_NAME = 'ItineraryIncidentSearchForm';

const ItineraryIncidentSearchForm = ({
  handleSubmit,
  onSubmitWithType,
  loading,
}) => {
  const locationTypeRef = useRef(null);

  const handleTypeSubmit = (type) => {
    locationTypeRef.current = type;
    handleSubmit((formValues) => {
      onSubmitWithType(formValues, locationTypeRef.current);
    })();
  };

  return (
    <Form>
      <FormGroup row>
        <FormItem label="Ubicación Actual" required>
          <Field
            name="location"
            component={LocationSelect}
            type="text"
            validate={[isRequired]}
            showOnlyAssigned
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Fecha" required>
          <Field
            name="dateString"
            component={DatePicker}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <Row>
        <Col className="flex row-reverse">
          <ButtonGroup>
            <Button
              color="info"
              type="button"
              disabled={loading}
              onClick={() => handleTypeSubmit('destination')}
            >
              <i className="fa fa-arrow-down" /> Llegada
            </Button>
            <Button
              color="warning"
              type="button"
              disabled={loading}
              onClick={() => handleTypeSubmit('source')}
            >
              <i className="fa fa-arrow-up" /> Salida
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    </Form>
  );
};

ItineraryIncidentSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmitWithType: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

ItineraryIncidentSearchForm.defaultProps = {
  loading: false,
};

export default reduxForm({
  form: FORM_NAME,
})(ItineraryIncidentSearchForm);
